"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const StyledSubHeader = (0, _mui.styled)('div')(({
  theme
}) => ({
  paddingBlock: `${theme.spacing(4)} ${theme.spacing(5)}`,
  paddingInline: theme.spacing(2)
}));
const StyledDialogContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  padding: theme.spacing(4, 0, 1, 0),
  position: 'relative',
  width: '680px',
  maxWidth: '100%'
}));
const CommonDialog = props => {
  const {
    width = '680px',
    isDialogOpen,
    onCloseDialog,
    header,
    subHeader,
    addressContent
  } = props;
  const headerContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      gutterBottom: true,
      variant: "h4",
      align: "center",
      children: header
    }), subHeader ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubHeader, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        paragraph: true,
        variant: "body1",
        align: "center",
        children: subHeader
      })
    }) : null]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
    open: isDialogOpen,
    header: headerContent,
    maxWidth: width,
    onClose: onCloseDialog,
    sx: {
      width: '100%'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDialogContent, {
      children: addressContent
    })
  });
};
exports.CommonDialog = CommonDialog;
//# sourceMappingURL=CommonDialog.js.map